import { ActionType } from './model'

import { createApiCall } from 'services'

import type { AxiosResponse } from 'axios'
import { call, put, fork, takeLatest } from 'redux-saga/effects'

import { ActionCallback } from '../model'

export function* getCustomersSaga(): Generator {
  yield takeLatest(ActionType.GET_CUSTOMERS, function* (action: ActionCallback) {
    const { payload, callback } = action
    try {
      const response: AxiosResponse = yield call(createApiCall, {
        url: '/customers/public',
        params: payload,
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: ActionType.SET_CUSTOMERS,
          payload: data,
        })
      }

      if (callback) {
      }
    } catch (e) {
      console.warn(e)
    }
  })
}

export default [fork(getCustomersSaga)]
